import axios from '../../axios'

/**
 * 1.0.1 获取机构场馆基本数据
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const get = agencyId => {
  return axios({
    url: '/clubVenue/agencyVenue/get/' + agencyId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/venue/agencyVenue.js